import { Box, Badge } from "@mui/material";
import React, { useContext } from "react";
import ShoppingCartOutlinedIcon from "@mui/icons-material/ShoppingCartOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined"; // Replacing with Order History Icon
import theme from "./../../theme";
import LogoutIcon from "@mui/icons-material/Logout";
import _LogoutService from "./../../service/LogoutService";
import { CartContext } from "../../context/CartContext";

function UserAccountState({ accountState, setAccountState, history }) {
  const handleLogout = () => {
    setAccountState(false); // Log the user out
    _LogoutService();
  };
  
  const { cartItemCount } = useContext(CartContext);

  if (!accountState) {
    return null;
  }

  return (
    <Box
      variant="div"
      sx={{
        display: "flex",
        flexDirection: "row",
        color: "#000000",
        gap: "30px",
      }}
    >
      <Badge
        badgeContent={cartItemCount}
        color="primary"
        sx={{ cursor: "pointer" }}
      >
        <ShoppingCartOutlinedIcon
          sx={{
            width: "25px",
            height: "25px",
            "&:hover": {
              color: theme.palette.hover.main,
            },
          }}
          onClick={() => {
            history.push("/card");
          }}
        />
      </Badge>
      <HistoryOutlinedIcon
        sx={{
          width: "25px",
          height: "25px",
          "&:hover": {
            color: theme.palette.hover.main,
          },
        }}
        onClick={() => {
          history.push("/orderList");
        }}
      />
      <LogoutIcon
        sx={{
          width: "25px",
          height: "25px",
          "&:hover": {
            color: theme.palette.hover.main,
          },
        }}
        onClick={handleLogout}
      />
    </Box>
  );
}

export default UserAccountState;
